import { useState, useEffect } from "react";

// Small localStorage-backed state for offline-first, per-device continuity.
export function usePersistentState(key, initial) {
  const storageKey = `ailab.${key}`;
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw != null ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      // ignore
    }
  }, [storageKey, value]);

  return [value, setValue];
}
